module.exports = __webpack_public_path__ + "img/arrow_left.9ea69fc1.png";